module.exports = __webpack_public_path__ + "static/img/logo.3a167a3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/img/logo.svg
// module id = ynWi
// module chunks = 1